module.exports = __webpack_public_path__ + "static/media/1.546aa8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/pants/1.png
// module id = 861
// module chunks = 0